import { ApiGenericResponse } from "../ApiGenericResponse";
import { InstallationScheduleConfiguration } from "@/model/data/scheduleSettings/InstallationScheduleSettings";
import { AxiosResponse } from "axios";
import { PaginatedServiceResponseData } from "../PaginatedServiceResponseData";

export class FetchInstallationsScheduleConfigurationResponse extends PaginatedServiceResponseData {
  installationsList: InstallationScheduleConfiguration[] = [];

  constructor(response: AxiosResponse) {
    super(response);
    if (response.data && response.data.Payload) {
      this.parse(response.data.Payload);
    }
  }

  public parse(obj: any) {
    if (obj.ResultList && obj.ResultList.length > 0) {
      obj.ResultList.forEach((e) => {
        var inst = new InstallationScheduleConfiguration();
        inst.parse(e);
        this.installationsList.push(inst);
      });
    }
  }
}
